export const environment = {
    dev: true,
    apiUrl: 'https://RCdevelopment.ciglobaltech.com',
    reportUrl: "https://app.powerbi.com/reportEmbed?reportId=83542be4-e976-400c-a12a-401274482b2a&groupId=31a20a29-8451-4f82-a1a2-ee87e31c27dd&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZX19",
    reportID: "83542be4-e976-400c-a12a-401274482b2a",
};